import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import { Fetcher } from '../../../Helpers/fetcher';
import { Notify } from '../../../Helpers/notification';
import UsernameAvailability from '../../../Components/UsernameAvailability';

const CreateSubSuperAdmin = ({ app }) => {
    const apiPath = app.apiPath
    const userId = app.userId
    const history = useHistory();

    const [formData, setFormData] = useState({
        username: '',
        password: '',
        confirmPassword: '',
        name: '',
        emailid: '',
        number: '',
        company: '',
        address: '',
        pincode: '',
        reportType: '',
        accountType: [],
        aclId: "",
        themeColor: '#2c5282',
        sidebarPosition: 'left',
        sendDate: new Date(),
        loading: false
    });
    const [aclList, setAclList] = useState([])
    const [usernameStatus, setUsernameStatus] = useState(null)

    const saveUiSettings = async (targetUserId, { themeColor, sidebarPosition }) => {
        try {
            await Fetcher.post(`${apiPath}/api/obd/user/${targetUserId}/ui/settings`, {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify({ json: JSON.stringify({ themeColor, sidebarPosition }) })
            });
        } catch (error) {
            console.log("saveUiSettings error", error);
        }
    };

    const encodeAccountType = (types) => {
        const hasPromotional = types.includes("0");
        const hasTransactional = types.includes("1");
        if (hasPromotional && hasTransactional) return 3;
        if (hasTransactional) return 1;
        if (hasPromotional) return 0;
        return "";
    };

    const toggleAccountType = (value) => {
        setFormData(prev => {
            const current = Array.isArray(prev.accountType) ? prev.accountType : [];
            const updated = current.includes(value)
                ? current.filter(v => v !== value)
                : [...current, value];
            return { ...prev, accountType: updated };
        });
    };

    const getAclList = async () => {
        try {
            const res = await Fetcher.get(`${apiPath}/api/obd/acl/setting/unallocated/list/${userId}`)
            const data = Array.isArray(res) ? res : []
            setAclList(data)
        } catch (error) {
            Notify.notify("Error while getting the module list")
            console.log("getAclList", error)
        }
    }

    const filterTime = (date) => {
        return new Date().getTime() <= date.getTime();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDateChange = (date) => {
        setFormData(prev => ({
            ...prev,
            sendDate: date
        }));
    };

    const addZero = (i) => (i < 10 ? "0" + i : i);

    const registerUser = (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            Notify.notify("Passwords do not match");
            return;
        }
        if (!formData.aclId) {
            Notify.notify("Select Acl before proceeding");
            return;
        }
        if (!formData.accountType.length) {
            Notify.notify("Select Account Type");
            return;
        }
        if (!formData.sendDate) {
            Notify.notify("Please select expiry date");
            return;
        }

        const d = formData.sendDate;
        const formattedDate = `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())} 23:59:59`;

        const data = {
            username: formData.username,
            password: formData.password,
            name: formData.name,
            emailid: formData.emailid,
            number: formData.number,
            address: formData.address,
            company: formData.company,
            pincode: formData.pincode,
            parent: userId,
            accountType: encodeAccountType(formData.accountType),
            userType: "sub_sadmin",
            expiryDate: formattedDate,
            aclId: Number(formData.aclId)
        };

        setFormData(prev => ({ ...prev, loading: true }));

        Fetcher.post(`${apiPath}/api/obd/register`,
            {
                headers: {
                    "Content-type": "application/json",
                },
                method: 'POST',
                body: JSON.stringify(data)
            }
        )
            .then(res => {
                if (res?.message?.toLowerCase().includes("success")) {
                    if (res?.userId) {
                        saveUiSettings(res.userId, {
                            themeColor: formData.themeColor,
                            sidebarPosition: formData.sidebarPosition
                        });
                    }
                    Notify.notify("User Created Successfully");
                    history.push("/sub-super-admin/user-list");
                    setFormData({
                        username: '',
                        password: '',
                        confirmPassword: '',
                        name: '',
                        emailid: '',
                        number: '',
                        company: '',
                        address: '',
                        pincode: '',
                        reportType: '',
                        accountType: [],
                        aclId: "",
                        themeColor: '#2c5282',
                        sidebarPosition: 'left',
                        sendDate: new Date(),
                        loading: false
                    });
                } else {
                    Notify.notify(res?.message || "Something went wrong");
                    setFormData(prev => ({ ...prev, loading: false }));
                }
            })
            .catch(err => {
                console.error(err);
                Notify.notify("Error creating user");
                setFormData(prev => ({ ...prev, loading: false }));
            });
    };

    useEffect(() => {
        getAclList()
    }, [])
    return (
        <Form onSubmit={registerUser}>
            <Row>
                <Col sm={12}>
                    <Card>
                        <Card.Header>Create New Sub Super Admin</Card.Header>
                        <Card.Body>
                            <Row>
                                <Col sm={4}>
                                    <Form.Control required name="username"
                                        placeholder="Username"
                                        value={formData.username}
                                        onChange={handleChange} />
                                    <UsernameAvailability apiPath={apiPath} username={formData.username} onStatusChange={setUsernameStatus} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="password"
                                        type="password"
                                        placeholder="Password"
                                        value={formData.password}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="confirmPassword"
                                        type="password"
                                        placeholder="Confirm Password"
                                        value={formData.confirmPassword}
                                        onChange={handleChange} />
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Control required name="name"
                                        placeholder="Name"
                                        value={formData.name}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="emailid"
                                        type="email"
                                        placeholder="Email ID"
                                        value={formData.emailid}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="number"
                                        placeholder="Mobile Number"
                                        value={formData.number}
                                        onChange={handleChange}
                                        onWheel={(e) => e.target.blur()}
                                    />

                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Control required name="company"
                                        placeholder="Company Name"
                                        value={formData.company}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="address"
                                        placeholder="Address"
                                        value={formData.address}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="pincode"
                                        placeholder="Pincode"
                                        value={formData.pincode}
                                        onChange={handleChange} />
                                </Col>


                            </Row>
                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Group className="form-group required control-label">
                                        <Form.Label>Select Account Type</Form.Label>
                                        <div className="d-flex gap-4 mt-1">
                                            <Form.Check
                                                type="checkbox"
                                                id="accountType-promotional"
                                                label="Promotional"
                                                checked={formData.accountType.includes("0")}
                                                onChange={() => toggleAccountType("0")}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                id="accountType-transactional"
                                                label="Transactional"
                                                checked={formData.accountType.includes("1")}
                                                onChange={() => toggleAccountType("1")}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Label>User Expiry</Form.Label>
                                    <DatePicker
                                        className="form-control"
                                        selected={formData.sendDate}
                                        minDate={new Date()}
                                        dateFormat="yyyy-MM-dd"
                                        onChange={handleDateChange}
                                        filterTime={filterTime}
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Form.Label>Select Acl</Form.Label>
                                    <Form.Select className="dd" required name="aclId" value={formData.aclId} onChange={handleChange} as="select" disabled={!aclList.length} >
                                        <option value="">
                                            {aclList.length ? "Select Acl" : "No ACL Available"}
                                        </option>
                                        {aclList.map(acl => {
                                            return <option key={acl.id} value={acl.id}>{acl?.aclName}</option>
                                        })}
                                    </Form.Select>
                                </Col>
                                <Col sm={4}>
                                    <Form.Label>Brand Color</Form.Label>
                                    <div className="d-flex align-items-center gap-2">
                                        <Form.Control
                                            type="color"
                                            name="themeColor"
                                            title="Choose brand color"
                                            value={formData.themeColor}
                                            onChange={handleChange}
                                            style={{ width: 48, height: 38, padding: 4 }}
                                        />
                                        <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                                            Shown on the sidebar and buttons when this user logs in
                                        </span>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Label>Sidebar Position</Form.Label>
                                    <div className="d-flex gap-4 mt-1">
                                        <Form.Check
                                            type="radio"
                                            id="sidebarPosition-left"
                                            name="sidebarPosition"
                                            label="Left"
                                            value="left"
                                            checked={formData.sidebarPosition === 'left'}
                                            onChange={handleChange}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="sidebarPosition-right"
                                            name="sidebarPosition"
                                            label="Right"
                                            value="right"
                                            checked={formData.sidebarPosition === 'right'}
                                            onChange={handleChange}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="sidebarPosition-top"
                                            name="sidebarPosition"
                                            label="Top"
                                            value="top"
                                            checked={formData.sidebarPosition === 'top'}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            {usernameStatus !== 'unavailable' && <Button className="mt-3"
                                variant="primary"
                                type="submit"
                                disabled={formData.loading}>
                                {formData.loading ? "Creating..." : "Create User"}
                            </Button>}

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Form>
    );
};

export default CreateSubSuperAdmin;